import { getRequest, postRequest } from './api';

const brandMetricsApi = {
  async getConfiguredBrands() {
    const res = await getRequest('/admin/brand-metrics/brands');
    return res?.data ?? res;
  },

  async getBrandsOverview(start, end) {
    const res = await getRequest(`/admin/brand-metrics/overview?start=${start}&end=${end}`);
    return res?.data ?? res;
  },

  // Reporte mensual on-demand: HTML autocontenido (string) para previsualizar en un iframe.
  async getMonthlyReportHtml(brandId, period) {
    const res = await getRequest(`/admin/reports/${brandId}?period=${period}`);
    return res?.data ?? res;
  },

  async getBrandPanel(brandId, start, end) {
    const res = await getRequest(
      `/admin/brand-metrics/${brandId}?start=${start}&end=${end}`
    );
    return res?.data ?? res;
  },

  async getMyPanel(start, end) {
    const res = await getRequest(`/brand-metrics/my-panel?start=${start}&end=${end}`);
    return res?.data ?? res;
  },

  // Daily Checklist: per-brand grid (metrics × last N days), cells pre-graded.
  async getBrandDailyChecklist(brandId, days = 30) {
    const res = await getRequest(`/admin/brand-metrics/${brandId}/daily-checklist?days=${days}`);
    return res?.data ?? res;
  },

  // Lead-gen panel: totals, pacing, breakdowns, momentum, CPL (from synced leads).
  async getBrandLeads(brandId, start, end) {
    const qs = start && end ? `?start=${start}&end=${end}` : '';
    const res = await getRequest(`/admin/brand-metrics/${brandId}/leads${qs}`);
    return res?.data ?? res;
  },
  // Pull the brand's leads Sheet into the warehouse; returns a sync summary.
  async syncBrandLeads(brandId) {
    const res = await postRequest(`/admin/brand-metrics/${brandId}/leads/sync`, {});
    return res?.data ?? res;
  },

  async getBrandCampaigns(brandId, start, end) {
    const res = await getRequest(
      `/admin/brand-metrics/${brandId}/campaigns?start=${start}&end=${end}`
    );
    return res?.data ?? res;
  },

  async getMyCampaigns(start, end) {
    const res = await getRequest(`/brand-metrics/my-campaigns?start=${start}&end=${end}`);
    return res?.data ?? res;
  },

  async getBrandCatalog(brandId, start, end) {
    const res = await getRequest(
      `/admin/brand-metrics/${brandId}/catalog?start=${start}&end=${end}`
    );
    return res?.data ?? res;
  },

  async getMyCatalog(start, end) {
    const res = await getRequest(`/brand-metrics/my-catalog?start=${start}&end=${end}`);
    return res?.data ?? res;
  },

  async getBrandCatalogHealth(brandId) {
    const res = await getRequest(`/admin/brand-metrics/${brandId}/catalog-health`);
    return res?.data ?? res;
  },

  async getMyCatalogHealth() {
    const res = await getRequest('/brand-metrics/my-catalog-health');
    return res?.data ?? res;
  },

  // Explorador de precio: `dropoffs` lista los que cayeron tras subir precio;
  // con `sku` trae la serie precio↔ventas; sin nada, busca por `q`.
  async getBrandPriceExplorer(brandId, { q, sku, dropoffs, changes } = {}) {
    const qs = changes ? 'changes=1' : dropoffs ? 'dropoffs=1' : sku ? `sku=${encodeURIComponent(sku)}` : `q=${encodeURIComponent(q || '')}`;
    const res = await getRequest(`/admin/brand-metrics/${brandId}/price-explorer?${qs}`);
    return res?.data ?? res;
  },

  async getMyPriceExplorer({ q, sku, dropoffs, changes } = {}) {
    const qs = changes ? 'changes=1' : dropoffs ? 'dropoffs=1' : sku ? `sku=${encodeURIComponent(sku)}` : `q=${encodeURIComponent(q || '')}`;
    const res = await getRequest(`/brand-metrics/my-price-explorer?${qs}`);
    return res?.data ?? res;
  },

  async getBrandCreativePreview(brandId, creativeId, adFormat = 'MOBILE_FEED_STANDARD') {
    const res = await getRequest(
      `/admin/brand-metrics/${brandId}/creatives/${creativeId}?ad_format=${adFormat}`
    );
    return res?.data ?? res;
  },

  async getMyCreativePreview(creativeId, adFormat = 'MOBILE_FEED_STANDARD') {
    const res = await getRequest(`/brand-metrics/my-creatives/${creativeId}?ad_format=${adFormat}`);
    return res?.data ?? res;
  },

  async getMyBrandLeads(start, end) {
    const qs = start && end ? `?start=${start}&end=${end}` : '';
    const res = await getRequest(`/brand-metrics/my-leads${qs}`);
    return res?.data ?? res;
  },

  // Analítica de clientes: cohortes, retención, RFM, LTV, geo, medios de pago,
  // top productos. Métricas de cliente = lifetime; top productos = rango.
  async getBrandCustomerAnalytics(brandId, start, end) {
    const qs = start && end ? `?start=${start}&end=${end}` : '';
    const res = await getRequest(`/admin/brand-metrics/${brandId}/customer-analytics${qs}`);
    return res?.data ?? res;
  },

  async getMyCustomerAnalytics(start, end) {
    const qs = start && end ? `?start=${start}&end=${end}` : '';
    const res = await getRequest(`/brand-metrics/my-customer-analytics${qs}`);
    return res?.data ?? res;
  },

  // Export de clientes de un segmento RFM (con email + nombre) para campañas.
  async getBrandSegmentExport(brandId, segment) {
    const res = await getRequest(
      `/admin/brand-metrics/${brandId}/customer-analytics/export?segment=${encodeURIComponent(segment)}`
    );
    return res?.data ?? res;
  },

  async getMySegmentExport(segment) {
    const res = await getRequest(
      `/brand-metrics/my-customer-analytics/export?segment=${encodeURIComponent(segment)}`
    );
    return res?.data ?? res;
  },
};

export default brandMetricsApi;
